import React, { useState, useEffect } from "react";
import TableLayout from "../Layout/TableLayout";
import { HeroiconsOutlineCalendar } from "../../assets/icons/LayoutIcon";

const EntryFormContent = ({ selectedObject }) => {
  const [date, setDate] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  const tableHeaders = [
    { label: " Product Name", value: "name" },
    { label: "Quantity", value: "quantity" },
  ];

  // Update filtered data when date or selectedObject changes
  useEffect(() => {
    if (!date) {
      setFilteredData(selectedObject.productLeadDatas || []);
    } else {
      const filtered = (selectedObject.productLeadDatas || []).filter((item) =>
        item.date?.startsWith(date)
      );
      setFilteredData(filtered);
    }
  }, [date, selectedObject]);
  // TODO: change filter functionality

  return (
    <div className="flex flex-col h-full relative">
      {/* Header */}
      <div className="sticky top-0 bg-white z-10 pb-8 pt-6 w-full px-4">
        <h1 className="text-text1 text-2xl sm:text-3xl font-bold">
          {selectedObject.username}
        </h1>
        <hr className="mt-5" />
      </div>

      <div className="px-4 ">
        <div className="w-full sm:w-1/2">
          <div className="flex-1">
            <div className="relative mt-1">
              <div className="absolute inset-y-0 left-0 px-3 bg-gray-50 border border-gray-300 rounded-tl-md rounded-bl-md flex items-center">
                <HeroiconsOutlineCalendar className="text-md text-gray-500" />
              </div>
              <div className="pl-10">
                <input
                  type="date"
                  id="date"
                  name="date"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  className="w-full custom-dateinput border rounded-md border-gray-300 focus:outline-none focus:ring-1 focus:ring-gray-300 appearance-none date-input-no-indicator"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Table */}
        <TableLayout data={filteredData} headers={tableHeaders} />
      </div>
    </div>
  );
};

export default EntryFormContent;
